<template>
  <div>
    <DetailAprovalPenerimaDana :activate="active" :itemData="itemPassData" @callback="callBackPopUp" />
    <vx-card>
      <!-- TABLE ACTION ROW -->
      <header class="w-full">
        <div class="mb-base mt-4 vx-row justify-between items-top">
          <section
            class="vx-col md:w-1/2 lg:w-1/2 xl:w-1/2 sm:w-full flex justify-start"
          >
            <span class="text-black text-2xl">Tabel Aproval Penerima Dana</span>
          </section>
          <!-- <section
            class="vx-col md:w-1/2 lg:w-1/2 xl:w-1/2 sm:w-full flex justify-end"
          >
            <vs-button @click="active = true">Tambah Campaign</vs-button>
          </section> -->
        </div>
        <div class="vx-row justify-between items-center">
          <section class="mb-base vx-col md:w-2/5 lg:w-2/5 xl:w-2/5 sm:w-full">
            <div class="w-full gap-2 flex justify-start items-center">
              <!-- <vs-dropdown
                vs-trigger-click
                class="cursor-pointer"
              >
                <vs-button icon-after icon="expand_more"
                  >Aksi</vs-button
                >
                
                <vs-dropdown-menu>
                  <vs-dropdown-item>
                    <span>Hapus</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown> -->
              <vs-dropdown vs-trigger-click class="cursor-pointer">
                <div
                  class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
                >
                  <span class="mr-2">{{ `entries ${limit}` }}</span>
                  <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                </div>
                <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                <vs-dropdown-menu>
                  <vs-dropdown-item
                    v-for="(item, index) in limitDataTables"
                    :key="index"
                    @click="limit = item"
                  >
                    <span>{{ item }}</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </div>
          </section>
          <section class="mb-base vx-col md:w-3/5 lg:w-3/5 xl:w-3/5 sm:w-full">
            <div class="w-full flex justify-end gap-2 flex-wrap items-center">
              <vs-input v-model="search" placeholder="Search..." />
            </div>
          </section>
        </div>

        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        <div
          class="flex flex-wrap items-center justify-between ag-grid-table-actions-right"
        ></div>
      </header>

      <main>
        <vs-table
          stripe
          :data="aprovals"
          v-model="selected"
          :max-items="limit"
          pagination
        >
          <template slot="thead">
            <vs-th>Nama Penerima</vs-th>
            <vs-th>Kategori</vs-th>
            <vs-th>Campaign</vs-th>
            <vs-th>Status</vs-th>
            <vs-th>Aksi</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td :data="data[indextr].namaPenerima">
                {{ data[indextr].namaPenerima }}
              </vs-td>
              <vs-td :data="data[indextr].kategori">
                {{ data[indextr].kategori }}
              </vs-td>
              <vs-td :data="data[indextr].campaign">
                {{ data[indextr].campaign }}
              </vs-td>
              <vs-td :data="data[indextr].status">
                <vs-dropdown vs-trigger-click>
                  <span
                    :class="
                      data[indextr].status === 1
                        ? 'text-success text-md'
                        : data[indextr].status === 2
                        ? 'text-danger text-md'
                        : 'text-black text-md'
                    "
                  >
                    {{ statusListAproval[data[indextr].status].text }}
                    <vs-icon class="" icon="expand_more"></vs-icon>
                  </span>

                  <vs-dropdown-menu>
                    <vs-dropdown-item
                      @click="data[indextr].status = item.id"
                      v-for="(item, index) in statusListAproval.filter(e => e.id !== 0)"
                      :key="index"
                    >
                      {{ item.text }}
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
              </vs-td>
              <vs-td>
                  <vs-button
                    color="primary"
                    type="filled"
                    icon-pack="feather"
                    icon-after
                    icon="icon-chevron-right"
                    @click="openPopUpWithData(data[indextr])"
                  >
                  Detail
                  </vs-button>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </main>
    </vx-card>
  </div>
</template>

<script>
import DetailAprovalPenerimaDana from "@/views/dana/component/DetailAprovalPenerimaDana.vue";
import limitDataTables from "@/limitDataTable.js";
import emptyImage from "@/assets/images/elements/empty.png";
import statusListAproval from "@/statusListAproval.js";

export default {
  components: {
    DetailAprovalPenerimaDana
  },
  data() {
    return {
      statusListAproval,
      emptyImage,
      limitDataTables,
      itemPassData : null,
      limit: limitDataTables[0],
      active: false,
      selected: [],
      tableList: [
        "vs-th: Component",
        "vs-tr: Component",
        "vs-td: Component",
        "thread: Slot",
        "tbody: Slot",
        "header: Slot"
      ],
      aprovals: [
        {
          namaPenerima: "Peduli umat",
          kategori: "Perorangan",
          deskripsi: "Bencana alam adalah bencana yang sangat mengerikan",
          latarBelakang: "Tertarik dengan campaign",
          campaign : "Dana Hibah Desa",
          status: 1
        },
        {
          namaPenerima: "Peduli umat",
          kategori: "Perorangan",
          deskripsi: "Bencana alam adalah bencana yang sangat mengerikan",
          latarBelakang: "Tertarik dengan campaign",
          campaign : "Dana Hibah Desa",
          status: 1
        },
        {
          namaPenerima: "Peduli umat",
          kategori: "Perorangan",
          deskripsi: "Bencana alam adalah bencana yang sangat mengerikan",
          latarBelakang: "Tertarik dengan campaign",
          campaign : "Dana Hibah Desa",
          status: 1
        }
      ],
      search: ""
    };
  },
  computed: {
    statusAprovalText(val) {
      return statusListAproval[val].text;
    }
  },
  methods: {
    callBackPopUp(val) {
      this.active = val;
    },
    openPopUpWithData (item) {
      console.log('isOpen')
      this.itemPassData = item
      this.active = true
    }
  }
};
</script>

<style lang="scss" scoped>
.text-success {
  color: green;
}
.text-danger {
  color: red;
}
.text-blue {
  color: blue;
}
img {
  max-height: 92px;
  max-width: 92px;
  overflow: auto;
}
</style>
